const adaptRosbankRequestBody = (body) => ({
  pointId: body.pointId[0].id,
  okved: body.okved,
  params: {
    type: body.type,
  },
});

export default adaptRosbankRequestBody;
